import { render, staticRenderFns } from "./BicCodeModal.vue?vue&type=template&id=3843ce43"
import script from "./BicCodeModal.vue?vue&type=script&lang=js"
export * from "./BicCodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports